import { memo } from 'react';
import loadable from '@loadable/component';
import { clarity } from 'react-microsoft-clarity';

import AppContainer from './components/Containers/AppContainer';
import ConnectErrorBoundary from './components/ConnectErrorBoundary';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IS_PRODUCTION } from './utils/constants';

dayjs.extend(utc);

if (IS_PRODUCTION) {
    clarity.init('q67urxl7tc');
    clarity.setTag('env', process.env.REACT_APP_CURRENT_ENVIRONMENT);
    clarity.setTag('app', 'intelyConnect');
}

const Snackbar = loadable(() => import('./components/Snackbar'));
const LoadingOverlay = loadable(() => import('./components/LoadingOverlay'));

const App = () => (
    <>
        <ConnectErrorBoundary>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Snackbar />
                <LoadingOverlay />
                <AppContainer />
            </LocalizationProvider>
        </ConnectErrorBoundary>
    </>
);

export default memo(App);
